// extracted by css-extract-rspack-plugin
export default {"count":"count-JdwnFD","name":"name-gjENhe","nameText":"nameText-fAJjBx","online":"online-_9r3fG"};